import { SHADOW_COLOR_ONE, WHITE } from 'src/global/theme/colors';
import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    mainContainer: { flex: 1, height: '100%'},
    container: {
      display: 'flex',
      alignItems: 'start',
      flexDirection: 'column',
      padding: "0 40px",
      boxSizing: 'border-box'
    },
    isBackground: {
      borderRadius: "8px",
      backgroundColor: WHITE,
      boxShadow: SHADOW_COLOR_ONE
    }
  };
});
